<template>
    <div class="l-nav-bar-typeahead">
        <vue-typeahead-bootstrap
            v-model="query"
            input-class="navbar-search navbar-search-input"
            :placeholder="placeholder"
            :data="users"
            :serializer="user => user.firstname + ' ' + user.lastname"
            :show-on-focus="true"
            @hit="showProfile($event)"
        >
            <template #prepend>
                <i class="far fa-search navbar-search-icon"></i>
            </template>
            <template #suggestion="{ data, htmlText }">
                <div style="display: flex">
                    <span style="margin-top: 4px; margin-left: -5px">
                        <l-profile-picture :user="data" size="s" />
                    </span>
                    <span style="margin-left: 10px">
                        <span v-html="htmlText"></span>
                        <br />
                        <span class="color-grey">{{ data.teamRole.title }} </span>
                    </span>
                </div>
            </template>
        </vue-typeahead-bootstrap>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";

import LProfilePicture from "@/components/LProfilePicture";

export default {
    components: {
        LProfilePicture,
        VueTypeaheadBootstrap,
    },
    props: {
        placeholder: {
            type: String,
            default() {
                return this.$t("menu.placeholderSearch");
            },
        },
    },
    data() {
        return {
            query: "",
        };
    },
    computed: {
        ...mapGetters({
            userSearchList: "users/search/list",
            getUserList: "users/list/list",
        }),
        users() {
            if (this.userSearchList.length) {
                return this.userSearchList;
            } else {
                return this.getUserList({ key: "directTeam" });
            }
        },
    },
    watch: {
        query(newQuery) {
            if (newQuery.length >= 2) {
                this.$store.dispatch("users/search/findByName", { query: newQuery });
            } else {
                this.$store.dispatch("users/search/reset");
            }
        },
    },
    created() {
        this.$store.dispatch({
            type: "users/list/get",
            payload: { userFilter: { include: { admin: [{ _id: "directTeam" }] } } },
        });
    },
    methods: {
        showProfile(user) {
            this.$router.push(`/profile/${user._id}`);
        },
    },
};
</script>

<style scoped>
.l-nav-bar-typeahead {
    margin-top: 12px;
    margin-left: 5px;
}

.l-nav-bar-typeahead >>> .navbar-search-icon {
    z-index: 3;
    font-size: 14px;
    top: 6px;
}

.l-nav-bar-typeahead >>> .navbar-search-input {
    height: 26px;
    padding-left: 15px;
    font-size: 14px !important;
    background-image: none !important;
    width: 160px;
}

.l-nav-bar-typeahead >>> .navbar-search-input::placeholder {
    font-size: 14px;
}

.l-nav-bar-typeahead >>> .vbt-autcomplete-list {
    background-color: #ffffff;
}
/* This is to override the inline styles added by the component ... */
.l-nav-bar-typeahead >>> .vbt-autcomplete-list[style] {
    margin-left: 0px !important;
    width: 300px !important;
    padding-top: 0;
    margin-top: 4px;
    border: 0;
    border-radius: 4px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
}

.l-nav-bar-typeahead >>> .navbar-search {
    padding: 3px 0px 3px 12px !important;
}

@media (max-width: 767px) {
    .l-nav-bar-typeahead >>> .input-group-prepend {
        display: none;
    }
    .l-nav-bar-typeahead >>> .vbt-autcomplete-list[style] {
        margin-left: 30px !important;
        width: 300px !important;
    }
}
</style>
